import { getToolbox } from "@saas/service-api/src/live-sdk";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      // 工具箱状态
      toolboxStatus: {
        timeout: {
          isRunning: false,
          isPaused: false,
          timerId: null,
          remainingSeconds: 0,
          version: 0,
        },
        interval: {
          isRunning: false,
          isPaused: false,
          timerId: null,
          remainingSeconds: 0,
          version: 0,
        },
        answerer: {
          allOption: [],
          endTime: 0,
          id: 0,
          questionType: 0,
          rightOption: [],
          roomId: 0,
          version: 0,
        },
      },
      // 工具箱弹窗状态
      toolboxVisible: {
        timeout: false,
        interval: false,
        answerer: false,
      },
    };
  },
  watch: {
    // 监听工具箱状态变化，自动打开对应的弹窗
    "toolboxStatus.timeout.isRunning"(val) {
      if (val && !this.toolboxVisible.timeout) {
        this.openToolbox("timeout");
        this.setShowToolbox({
          timeout: true,
        });
      }
    },
    "toolboxStatus.timeout.isPaused"(val) {
      if (val && !this.toolboxVisible.timeout) {
        this.openToolbox("timeout");
        this.setShowToolbox({
          timeout: true,
        });
      }
    },
    "toolboxStatus.interval.isRunning"(val) {
      if (val && !this.toolboxVisible.interval) {
        this.openToolbox("interval");
        this.setShowToolbox({
          interval: true,
        });
      }
    },
    "toolboxStatus.interval.isPaused"(val) {
      if (val && !this.toolboxVisible.interval) {
        this.openToolbox("interval");
        this.setShowToolbox({
          interval: true,
        });
      }
    },
    "toolboxStatus.answerer.id"(val) {
      if (val && !this.toolboxVisible.answerer) {
        this.openToolbox("answerer");
        this.setShowToolbox({
          answerer: true,
        });
      }
    },
  },
  methods: {
    ...mapMutations("live", ["setShowToolbox"]),
    // 初始化工具箱状态
    async initToolboxStatus() {
      try {
        const response = await getToolbox({
          room_id: this.roomInfo.id,
        });
        console.log("response__", response);

        if (response.data && response.code === 1) {
          // 更新定时器状态
          if (response.data.countdown) {
            this.updateToolboxStatus(
              "timeout",
              response.data.countdown,
              response.serverTime
            );
            // 如果定时器正在运行或暂停，自动打开弹窗
            if (
              this.toolboxStatus.timeout.isRunning ||
              this.toolboxStatus.timeout.isPaused
            ) {
              this.openToolbox("timeout");
            }
          }

          // 更新计时器状态
          if (response.data.stopwatch) {
            this.updateToolboxStatus(
              "interval",
              response.data.stopwatch,
              response.serverTime
            );
            // 如果计时器正在运行或暂停，自动打开弹窗
            if (
              this.toolboxStatus.interval.isRunning ||
              this.toolboxStatus.interval.isPaused
            ) {
              this.openToolbox("interval");
            }
          }

          // 更新答题器状态
          if (response.data.question) {
            this.updateToolboxStatus(
              "answerer",
              response.data.question,
              response.serverTime
            );
            // 如果答题器正在运行或暂停，自动打开弹窗
            if (
              this.toolboxStatus.answerer.isRunning ||
              this.toolboxStatus.answerer.isPaused
            ) {
              this.openToolbox("answerer");
            }
          }
        }
      } catch (error) {
        console.error("获取工具箱状态失败:", error);
      }
    },

    // 更新工具箱状态
    updateToolboxStatus(toolType, data, currentTime) {
      if (!this.toolboxStatus[toolType]) {
        this.toolboxStatus[toolType] = {
          isRunning: false,
          isPaused: false,
          timerId: null,
          remainingSeconds: 0,
          version: 0,
        };
      }

      const status = this.toolboxStatus[toolType];

      // 根据工具类型处理不同的数据结构
      switch (toolType) {
        case "timeout":
          if ([1, 2].includes(data.timer_state)) {
            status.isRunning = data.timer_state === 1;
            status.isPaused = data.timer_state === 2;
            status.timerId = data.id;
            status.remainingSeconds = status.isPaused
              ? data.downtime
              : data.timer_second -
              (parseInt(currentTime / 1000) -
                data.start_time -
                data.total_downtime);
            status.version = data.version || 0;
          } else {
            // 重置状态
            status.isRunning = false;
            status.isPaused = false;
            status.timerId = null;
            status.remainingSeconds = 0;
            status.version = 0;
          }
          break;

        case "interval":
          if ([1, 2].includes(data.timer_state)) {
            status.isRunning = data.timer_state === 1;
            status.isPaused = data.timer_state === 2;
            status.timerId = data.id;
            // 计时器是往上计时的，所以直接使用elapsed_seconds
            status.remainingSeconds = status.isPaused
              ? data.downtime
              : parseInt(currentTime / 1000) -
              data.start_time -
              data.total_downtime;
            status.version = data.version || 0;
          } else {
            // 重置状态
            status.isRunning = false;
            status.isPaused = false;
            status.timerId = null;
            status.remainingSeconds = 0;
            status.version = 0;
          }
          break;

        case "answerer":
          this.toolboxStatus[toolType] = {
            allOption: data.all_option,
            endTime: data.end_time,
            id: data.id,
            questionType: data.question_type,
            rightOption: data.right_option,
            roomId: data.room_id,
            version: data.version,
            subOption: data.sub_option,
            createdAt: data.created_at,
            serverTime: currentTime,
            answerTime: data.answer_time,
          };
          break;
      }
    },

    // 打开工具箱弹窗
    openToolbox(toolType) {
      if (this.toolboxVisible[toolType] !== undefined) {
        this.toolboxVisible[toolType] = true;
        this.setShowToolbox({
          [toolType]: true,
        });
      }
    },
  },
};
